export default __webpack_public_path__ + "static/marketplace-fraud-img-1-cab1fba728e2def251396ed9055bbcb8.svg";